/* eslint-disable no-use-before-define */
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { debugValue } from './debug';

export const useSteps = ({ steps, sites }) => {
  const [stepIndex, setStepIndex] = useState(debugValue(0, 'stepIndex'));

  const nextIndex = getStepIndex(stepIndex, 1, steps, sites);
  const previousIndex = getStepIndex(stepIndex, -1, steps, sites);

  const toNextPage = (updatedSites) => {
    const actualSites = Array.isArray(updatedSites) ? updatedSites : sites;
    setStepIndex(getStepIndex(stepIndex, 1, steps, actualSites));
  };

  const toPreviousPage = (updatedSites) => {
    const actualSites = Array.isArray(updatedSites) ? updatedSites : sites;
    setStepIndex(getStepIndex(stepIndex, -1, steps, actualSites));
  };

  const navItems = steps
    .map((step, index) => {
      switch (step) {
        case 'questionnaire':
          return {
            index,
            label: (
              <FormattedMessage
                key="questions"
                defaultMessage="Questions"
                id="Modal.NavProgressStudyQuestions"
              />
            ),
          };

        case 'clinicForm':
          return {
            index,
            label: (
              <FormattedMessage
                key="location"
                defaultMessage="Location"
                id="Modal.LocationPreference"
              />
            ),
          };

        case 'contactDetails':
          return {
            index,
            label: (
              <FormattedMessage
                key="contact"
                defaultMessage="Contact"
                id="Modal.NavProgressContactDetails"
              />
            ),
          };

        default:
          return null;
      }
    })
    .filter(Boolean);

  return {
    stepIndex,
    navItems,
    toNextPage,
    toPreviousPage,
    nextIndex,
    previousIndex,
    pageName: steps[stepIndex],
    hasNextPage: nextIndex < steps.length,
  };
};

export const getStepIndex = (index, direction, steps, sites) => {
  let newIndex = index + direction;
  const skippable = ['clinicForm', 'questionnaire.eligible'];

  while (skippable.includes(steps[newIndex])) {
    if (steps[newIndex] === 'clinicForm' && sites?.length <= 1) {
      newIndex += direction;
    } else if (steps[newIndex] === 'questionnaire.eligible') {
      newIndex += direction;
    } else break;
  }

  return newIndex;
};
